import useSWR from "swr";
import type { SwrReturnType } from "~/models/Api";
import type { CompanyVendor } from "~/models/CompanyVendor";

const paths = {
	index: "/company_vendors"
};
type TIndex = () => SwrReturnType<CompanyVendor[]>;
type ReturnType = {
	index: TIndex;
};

export const useCompanyVendors = (): ReturnType => {
	const index: TIndex = () => {
		// eslint-disable-next-line react-hooks/rules-of-hooks
		const { data, mutate, error } = useSWR<CompanyVendor[]>(paths.index);
		return {
			data: data ?? [],
			error,
			isLoading: !data && !error,
			mutate
		};
	};
	return { index };
};
